export interface initStateDataProps {
    ticketActivity: number, // 当前页卡索引值
    ticketInfoList: Array<Record<string, any>>;
}

export interface ticketProps {
    assigneeId?: number,
    assigneeName?: string,
    businessType?: number,
    businessTypeName?: string,
    businessTypeSub?: number,
    businessUnit?: string,
    canonicalCountryCode?: string,
    category?: any,
    channel?: number,
    channelName?: string,
    channelType?: number,
    cityId?: number,
    cityName?: string,
    clipperId?: string,
    clipperType?: number,
    closerId?: number,
    complaintId?: number,
    complaintName?: string,
    complaintOrderId?: number,
    complaintPhone?: string,
    complaintResult?: string,
    complaintType?: number,
    complaintUrl?: string,
    content?: string,
    creatorId?: number,
    creatorName?: string,
    currentManualTimes?: number,
    customFields?: string,
    customMap?: any
    description?: string,
    email?: string,
    emailStatus?: number,
    externalId?: string,
    externalSourceName?: string,
    extraFields?: string,
    extraFieldsIsAsync?: string,
    extraValueMap?: any,
    flowId?: string,
    groupId?: number,
    groupName?: string,
    id?: string,
    innerReplyTimes?: number,
    isAuto?: number,
    isRoaming?: number,
    isTransferClipper?: number,
    levelName?: string,
    localAssignTime?: string,
    localCloseTime?: string,
    localCreateTime?: string,
    localFirstRespTime?: string,
    localLastRespTime?: string,
    localPendingTime?: string,
    localRequesterLastTime?: string,
    localUpdateTime?: string,
    localWaitTime?: string,
    manualProcessTimes?: number,
    orderId?: string,
    orderOffset?: number,
    organizationId?: number,
    outerReplyTimes?: number,
    priority?: number,
    processId?: number,
    productId?: number,
    registerPhonePrefix?: string,
    registerPhoneSubscriber?: string,
    requesterId?: number,
    requesterName?: string,
    requesterPhone?: string,
    requesterPhonePrefix?: string,
    requesterReplyTimes?: number,
    requesterType?: number,
    requesterTypeName?: string,
    requesterUrl?: string,
    driverId?: number,
    passengerId?: number,
    searchType?: number,
    searchValue?: string,
    source?: string,
    status?: number,
    statusName?: string,
    subject?: string,
    sysOuterReplyTimes?: number,
    tags?: string,
    ticketLevel?: number,
    ticketid?: string,
    utcAssignTime?: string,
    utcCloseTime?: string,
    utcCreateTime?: string,
    utcFirstRespTime?: string,
    utcLastRespTime?: string,
    utcOffset?: number,
    utcPendingTime?: string,
    utcRequesterLastTime?: string,
    utcUpdateTime?: string,
    utcWaitTime?: string,
}

export interface initTicketProps {
    id: string;
    info?: ticketProps;
    status: Boolean;
    data?: Record<string, any>;
    timeStamp?: number;
    formCheck: number;
    order?: Record<string, any>;
    requester?: Record<string, any>;
    complaint?: Record<string, any>;
    ticket?: Record<string, any>;
    message?: Record<string, any>;
    sop?: Record<string, any>;
    reply?: Record<string, any>;
}

export const initStateData: initStateDataProps = {
    ticketActivity: 0, // 当前页卡索引值
    ticketInfoList: []
}

export interface initTicketDetailProps {
    id: string;
}

export const initTicketData: initTicketDetailProps = {
    id: '',
}

export function createInitTicketState() {
    const initTicketData: initTicketProps = {
        id: '',  // 初始化工单ID
        // 工单状态 false：详情页 true：处理页/创建页
        status: true,
        // 存放findTicketById 数据
        info: {},
        // 存放展示的一些信息，不一定保留
        data: {},
        // 监听 表单校验 变量
        formCheck: 0,
        // 监听 订单提交时触发表单校验 变量
        // 订单相关
        order: {},
        // 进线人信息相关
        requester: {},
        // 被投诉人信息相关
        complaint: {},
        // 工单相关
        ticket: {},
        // 回复信息相关
        message: {},
        // 人工sop
        sop: {},
        // 回复区
        reply: {},
    }
    return initTicketData;
}
